import Vue from 'vue';
import ReportContainer from './Report/ReportContainer.js';
import axios from 'axios';

import Component from 'vue-class-component';

@Component
export default class App extends Vue {
	constructor(){
		super();
		this.isThrobber = "";
		this.counter_req = 0;
		this.counter_res = 0;
	}
	created (){
		let self = this;

		axios.interceptors.request.use(function (config) {
			self.$data.counter_req++;
			
			return config;
		}, function (error) {
			return Promise.reject(error);
		});

		axios.interceptors.response.use(function (response) {
			self.$data.counter_res++;
			
			return response;
		}, function (error) {
			return Promise.reject(error);
		});
	}
	beforeUpdate (){
		if (window.location.href.indexOf("auth")+1){
			this.$data.isThrobber = "";
		}
		else if (this.$data.counter_req != this.$data.counter_res){
			this.$data.isThrobber = "throbber";
		}
		else{
			this.$data.isThrobber = "";
		}
	}
	render (h)  {
		return(
			<div> 
				<router-view></router-view>		
				<div class={this.$data.isThrobber}></div>
				<style jsx>{`
					body{
						margin: 0 auto;
						font-family: 'Open Sans';
					}
					body,html{
						height: 100%;
					}
					body.style_body { height:100%}

					.throbber{
						background-color: rgba(0,0,0,0.5);
						position: fixed;
						left: 0;
						top: 0;
						width: 100%;
						height: 100%;
						z-index: 9999;
					}

					@font-face{
						font-family: 'Open Sans';
						src: url('assets/font/open_sans.ttf') format('truetype');
						font-weight: normal;
						font-style: normal;
					}
				`}</style>
			</div>
		);
	}
}


//


// WEBPACK FOOTER //
// ./src/App.js